<template>
    <div class="choose-area-dialog" v-if="show">
        <span v-if="isItem" style="cursor: pointer;color: #A1000F;" @click="closeItem()"> &lt; Quay lại</span>
        <div class="header-choose">
            <b>{{ title }}</b>
            <i class="pi pi-times" style="cursor: pointer;" @click="$emit('backToList')"/>
        </div>
        <div class="body-choose" v-if="data.length > 0">
            <div class="type">
                <div class="choose-radio" v-if="type == 'radio'">
                    <div class="choose-radio-items" v-for="(item, index) in data" :key="`radio-${item.id}-${index}`" @click="openItem(item?.items ?? [], item.id)">
                        <RadioButton v-model="dataItem" :id="`radio-${item.id}-${index}`" :name="item.type" :value="item.id"/>
                        <label :for="`radio-${item.id}-${index}`" class="ml-2 d-flex justify-content-between w-100 align-items-center">
                            {{item.name}}
                            <div v-if="item?.items">
                                <span> ({{ itemSelect[item.id] ? itemSelect[item.id].length : 0 }} / {{ item.items.length }}) </span>
                                <i class="pi pi-cog"/>
                            </div>
                        </label> 
                    </div>
                </div>
                
                <div class="choose-checkbox" v-else-if="type == 'checkbox'">
                    <div class="choose-radio-items" v-for="(item, index) in data" :key="`checkbox-${item.id}-${index}`">
                        <Checkbox v-model="checkItem[item.id]" :id="`checkbox-${item.id}-${index}`" name="item-data" :value="item.id" />
                        <label :for="`checkbox-${item.id}-${index}`" class="ml-2 d-flex justify-content-between w-100 align-items-center">
                            {{item.name}}
                            <div>
                                <InputNumber style="width: 30px; height: 30px;" v-model="totalItem[parentId][item.id]" locale="de-DE" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="item?.number ?? totalMaxById[item.id]" @input="changeTotalItem"/>
                                <span>/ {{ item?.number ?? totalMaxById[item.id]}}</span>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="d-flex align-items-center empty-items justify-content-center">
            <span>Không có dữ liệu</span>
        </div>
        <chooseAreaItem 
            v-if="items" 
            :data="items" 
            :title="checkItems.length > 0 ? 'Chọn khu vực - Hàng' : 'Chọn khu vực - Hộp'" 
            @itemSelect="checkValue" 
            :parentId.sync="parent_id"
            :value="itemSelect[parent_id]"
            :type="checkItems.length > 0 ? 'radio' : 'checkbox'" 
            :total="total" :totalMaxium="totalMax" :show="showItem" 
            @closeItem="showItem = false" :isItem="true" @emitTotal="emitTotal"
            :parentValue="parentValue"
            ref="myChooseArea" 
            :showBg="showBg"
            :key="keyItem"
            @backToList="$emit('backToList')"
            @saveData="$emit('saveData')"
        />
        <div class="footer-choose" v-if="type == 'checkbox'">
            <Button
                :label="$constants.TEXT_BUTTON.BACK"
                @click="backToList()"
                class="p-button-warning return-style-button" />
            <Button
                label="Lưu"
                @click="saveData()"
                class="p-button-success main-style-button" 
            />
        </div>
    </div>
</template>


<script>
export default {
  name: 'chooseAreaItem',
  props: {
    title: String,
    total: Number,
    totalMaxium: Number,
    data: Array,
    show: {
        type: Boolean,
        default: false
    },
    type: {
        type: String,
        default: "radio"
    },
    value: Array,
    isItem: Boolean,
    parentId: String,
    parentValue: Array,
    showBg: Boolean,
  },
  mounted() {
    this.totalMax = this.$props.totalMaxium;
    this.totalItem[this.parentId] = this.totalItem[this.parentId] ?? [];
    this.loadData();
  },
  watch: {
    "$props.showBg"() {
        if (!this.showBg) {
            this.$emit('backToList');
        }
    },
    async "data"() {
        this.totalItem[this.parentId] = this.totalItem[this.parentId] ?? [];
        this.loadData();
    },
    "parentId"() {
        this.totalItem[this.parentId] = this.totalItem[this.parentId] ?? [];
        this.loadData();
    },
    async "$props.value"() {
        this.totalItem[this.parentId] = this.totalItem[this.parentId] ?? [];
        // console.log("this.valuethis.valuethis.value", this.value);
        if (this.value && this.value.length > 0) {
            await this.value.map(m => {
                if (this.type == 'checkbox') {
                    this.$set(this.totalItem[this.parentId], m.id, m.value);
                } else {
                    this.itemSelect[m.id] = m.value;
                }
            })            
        }
        this.loadData();
    },
    // "itemSelect"() {
    //     console.log("parentValueparentValueparentValue", this.itemSelect);
    // }
  },
  data() {
    return {
        parent_id: null,
        totalMax: 0,
        items: [],
        checkItems: [],
        dataItem: null,
        itemSelect: [],
        totalItem: [],
        totalMaxById: {},
        checkItem: {},
        showItem: false,
        showPopup: false,
        keyItem:0
    }
  },
  methods: {
    loadData() {
        var arr_ids = Object.keys(this.totalItem[this.parentId]);
        var totalTmp = this.totalMax;
        var value = [];
        arr_ids.map(m => {
            value.push({
                id: m,
                value: this.totalItem[this.parentId][m]
            })
            // if (this.totalItem[this.parentId][m] && this.totalItem[this.parentId][m] > 0) {
            //     this.checkItem[m] = [m];
            // } else {
            //     this.checkItem[m] = Array();
            // }
            // this.totalMaxById[m] = totalTmp;
            this.$set(this.totalMaxById, m, totalTmp);
            if (this.totalMaxById[m] <= 0) {
                this.totalMaxById[m] = 0;
                // this.totalItem[this.parentId][m] = 0;
                // this.checkItem[m] = Array();
            } else if (this.totalMaxById[m] < this.totalItem[this.parentId][m]) {
                this.totalItem[this.parentId][m] = this.totalMaxById[m];
            }
            totalTmp -= this.totalItem[this.parentId][m];
        })
        this.data.map(m => {
            if (this.totalItem[this.parentId][m.id] && this.totalItem[this.parentId][m.id] > 0) {
                this.checkItem[m.id] = [m.id];
            } else {
                // this.totalMaxById[m.id] = totalTmp;
                this.$set(this.totalMaxById, m.id, totalTmp);
                this.checkItem[m.id] = Array();
            }
        })
        return {value, totalTmp};
    },
    emitTotal(data) {
        this.totalMax = (this.total - data);
    },
    changeTotalItem() {
        const {value, totalTmp} = this.loadData();
        this.$emit("emitTotal", (this.total - totalTmp));
        this.$emit("itemSelect", {data: value, parent_id: this.parentId});
        this.keyItem++;
    },
    async openItem(items, id) {
        this.items = items;
        this.$set(this, "parent_id", id);
        // console.log("valueee", this.value);
        // console.log("itemSelect", this.itemSelect);
        this.itemSelect[id] = this.value[id] ?? (this.itemSelect[id] ?? []);
        this.checkItems = items.filter(f => f.items);
        this.showItem = true;
    },
    async closeItem() {
        this.$set(this, "parent_id", null);
        this.itemSelect[this.parent_id] = this.itemSelect[this.parent_id] ?? [];
        this.$emit("closeItem", false);
    },
    checkValue({parent_id, data}) {
        var value = this.value;
        if (this.value.length > 0) {
            this.value.map(m => {
                if (parent_id == m.id) {
                    let val = [];
                    m.value = [];
                    data.map(n => {
                        if (n.value) {
                            val.push(n);
                        }
                    });
                    m.value.push(...val);
                } else {
                    value.push({
                        value: data,
                        id: parent_id
                    })
                }
            })
        } else {
            value.push({
                value: data,
                id: parent_id
            })
        }
        this.itemSelect[parent_id] = data.filter(f => f.value && f.value > 0);
        this.$emit("itemSelect", {data: value, parent_id: this.parentId});
    },
    saveData() {
        this.$emit("saveData");
    },
    backToList() {
        this.$emit("backToList");
    }
  }
}
</script>